import toMap from '~/misc/toMap';

export default toMap([
  'RESOURCE',
  'RESOURCE_NEEDED',
  'RESOURCE_NOT_NEEDED',
  'RESOURCE_REQUESTED',
  'RESOURCE_DISPOSED',
  'RESOURCE_UPDATED_DEP',
  'RESOURCE_SAVE_BROKER',
  'RESOURCE_REMOVE_BROKER',
  'RESOURCE_LOAD_SAVE_BROKER',
  'RESOURCE_LOAD_REMOVE_BROKER',
]);



// WEBPACK FOOTER //
// ./src/modules/resources/types.js